import { render } from "./ModalDialogSignature.vue?vue&type=template&id=54e453f3&scoped=true"
import script from "./ModalDialogSignature.vue?vue&type=script&lang=js"
export * from "./ModalDialogSignature.vue?vue&type=script&lang=js"

import "./ModalDialogSignature.vue?vue&type=style&index=0&id=54e453f3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e453f3"]])

export default __exports__